import React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import TablaNotasDocente from "./componentes/tablaNotasDocente"
import EstudianteNotas from "./componentes/estudianteNotas";
import Academicos from "./componentes/academicosNotas"
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

const Notas = () => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    const rol = user?.rol;
  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>

          <Grid item xs={12}>
            <Card>

              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                borderRadius="lg"
                coloredShadow="info"
                sx={{
                  background: "linear-gradient(45deg, #e60000, #ff3300)",
                  color: "white",
                }}
              >
                <MDTypography variant="h6" color="white">
                  Registro de Notas
                </MDTypography>
              </MDBox>
              {rol === 3 ? (
                <TablaNotasDocente />
              ) : rol === 4 ? (
                <EstudianteNotas />
              ) : (
                <Academicos />
              )}
            </Card>
          </Grid>

        </Grid>
      </MDBox>

      <Footer />
    </DashboardLayout>
  );
};

export default Notas;